class ApiImprint {
	constructor($http, GenericMethods){
		return {
			//returns the details to be displayed on imprint page
			getImprintDetails(){
				return GenericMethods.retrieveLocalFile('data/', 'imprintDetails.json');
			}
		}
	}
}

ApiImprint.inject = ['$http'];

export default ApiImprint;


/** WEBPACK FOOTER **
 ** ./src/app/services/apiImprint.js
 **/